
export default {
  name: 'EmptyLayout',
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pageNotFound: '404 Not Found',
      otherError: 'An error occurred',
      redirectTime: 3,
    }
  },
  head() {
    const title =
      this.error.statusCode === 404 ? this.pageNotFound : this.otherError
    return {
      title,
    }
  },
  mounted() {
    const intervalId = setInterval(() => {
      if (this.redirectTime > 0) {
        this.redirectTime -= 1
      } else {
        clearInterval(intervalId)
        this.$router.push('/')
      }
    }, 1000)
  },
}
